// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3352":"48b4a64f9d5b4212f93e","8922":"6a415cbabb228ffac041"}[chunkId] + ".js";
};